/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsThreadChartListItem,
    ControlcenterMelcoModelsThreadChartListItemFromJSON,
    ControlcenterMelcoModelsThreadChartListItemFromJSONTyped,
    ControlcenterMelcoModelsThreadChartListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsThreadChartListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem
     */
    list: Array<ControlcenterMelcoModelsThreadChartListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem {
    return ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsThreadChartListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsThreadChartListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsThreadChartListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


